import React from 'react';
import { Link } from 'react-router-dom';

export class NotAvailable extends React.Component {
  render() {
    return (
      <section id='NotAvailableDisplay'>
        <div className='row'>
          <div className='col-sm-12'>
            <div id='error-message' className='alert alert-danger' role='alert'>
              This item is not available for internet purchase.
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default NotAvailable;
